import { createCss, createHslaColorCss, createSizeCss } from '@rybr/styled-modules'

import { BREAK_POINT_WIDTH, Z_INDEXES } from '../constants/constants.css'

const sizes = createSizeCss({ prefix: 'size', steps: 36 })
const borderWidths = createSizeCss({ prefix: 'border-width', steps: 5, incrementBy: 0.05 })
const panels = createSizeCss({ prefix: 'panel', steps: 15, incrementBy: 5 })
const fontSizes = createSizeCss({ prefix: 'font-size', steps: 50, incrementBy: 0.125 })

export type ThemeBase = typeof themeBase

export const themeBaseConfig = {
  ...sizes,
  ...panels,
  ...fontSizes,

  'font-family': 'var(--nextjs-font-family-roboto)',
  'font-family-grotesk': 'var(--nextjs-font-family-grotesk)',
  'font-family-fellix': 'var(--nextjs-font-family-fellix)',

  'shadow-1': '0px 1px 3px 0px rgba(166, 175, 195, 0.40)',
  'shadow-2': '0px 5px 12px 0px rgba(0, 0, 0, 0.10)',
  'shadow-3': '0px 4px 12px 0px rgba(13, 10, 44, 0.06)',
  'shadow-4': '0px 10px 15px 0px rgba(5, 13, 29, 0.18)',
  'shadow-5': '0px 34px 26px 0px rgba(13, 10, 44, 0.05), 0px 12px 34px 0px rgba(13, 10, 44, 0.08)',
  'shadow-6': '0px 20px 20px 0px rgba(5, 13, 29, 0.20)',

  'size-2xs': sizes['size-2'],
  'size-xs': sizes['size-4'],
  'size-sm': sizes['size-8'],
  'size-md': sizes['size-12'],
  'size-lg': sizes['size-18'],
  'size-xl': sizes['size-26'],
  'size-2xl': sizes['size-36'],

  'font-size-xs': fontSizes['font-size-3'],
  'font-size-sm': fontSizes['font-size-5'],
  'font-size-md': fontSizes['font-size-7'],
  'font-size-lg': fontSizes['font-size-13'],
  'font-size-xl': fontSizes['font-size-21'],
  'font-size-2xl': fontSizes['font-size-35'],

  'screen-mobile': BREAK_POINT_WIDTH.mobile,
  'screen-tablet': BREAK_POINT_WIDTH.tablet,
  'screen-desktop': BREAK_POINT_WIDTH.desktop,

  'border-radius-sm': sizes['size-1'],
  'border-radius-md': sizes['size-3'],
  'border-radius-lg': sizes['size-5'],
  'border-radius-xl': sizes['size-7'],

  'border-width-xs': borderWidths['border-width-1'],
  'border-width-sm': borderWidths['border-width-2'],
  'border-width-md': borderWidths['border-width-3'],
  'border-width-lg': borderWidths['border-width-4'],
  'border-width-xl': borderWidths['border-width-5'],

  'font-weight-light': '300',
  'font-weight-regular': '400',
  'font-weight-medium': '500',
  'font-weight-semibold': '600',
  'font-weight-bold': '700',
  'font-weight-black': '900',

  ...createHslaColorCss({
    prefix: 'color-gray',
    hue: 80,
    saturation: 0,
    steps: 5
  }),

  ...createHslaColorCss({
    prefix: 'color-red',
    hue: 0,
    saturation: 100,
    steps: 5
  }),

  ...createHslaColorCss({
    prefix: 'color-blue',
    hue: 230,
    saturation: 100,
    steps: 5
  }),

  ...createHslaColorCss({
    prefix: 'color-green',
    hue: 125,
    saturation: 100,
    steps: 5
  }),

  'color-neutral-1': '#FFFFFF',
  'color-neutral-2': '#F4F4F4',
  'color-neutral-3': '#D3D3D3',
  'color-neutral-4': '#A8A8A8',
  'color-neutral-5': '#666666',
  'color-neutral-6': '#000000',

  'z-index-header': Z_INDEXES.header,
  'z-index-modal': Z_INDEXES.modal,
  'z-index-modal-backdrop': Z_INDEXES.modalBackdrop,
  'z-index-loader': Z_INDEXES.loader,
  'z-index-alert': Z_INDEXES.alert
}

export const themeBase = createCss(themeBaseConfig)
